// The size of an event as the database keeps it (the 2026-10-10 review's finding 2). `vtt.table_event.payload` is
// jsonb, checked `char_length(payload::text) <= 65536` (db/changelog/vtt/002-events.xml), and jsonb's text form is not
// `JSON.stringify`'s: a space after every `:` and `,`, and a number written out in full (`1e21` is 22 digits). So the
// check counts that form, exactly, before the INSERT, and a change too large to keep is refused in words.
/** The most characters a stored event's jsonb text may have (vtt/002-events.xml). */
export const STORED_EVENT_MAX = 65_536;
export const TOO_LARGE_TO_SAVE = 'That change is too large to save.';
/** A number's length as jsonb writes it: JSON's own form, but an exponent written out in full. */
function numberLength(n) {
    const s = JSON.stringify(n);
    const e = s.indexOf('e');
    if (e < 0)
        return s.length;
    const sign = s.startsWith('-') ? 1 : 0;
    const digits = s.slice(sign, e).replace('.', '');
    const x = Number(s.slice(e + 1));
    // 1.5e+21 → 1500000000000000000000; 1.5e-7 → 0.00000015.
    return x >= 0 ? sign + Math.max(digits.length, x + 1) : sign + 2 + (-x - 1) + digits.length;
}
/** A string's characters as Postgres counts them: code points, so a pair of UTF-16 surrogates is one. */
function textLength(s) {
    const json = JSON.stringify(s);
    let pairs = 0;
    for (let i = 0; i < json.length; i++) {
        const c = json.charCodeAt(i);
        if (c >= 0xd800 && c <= 0xdbff)
            pairs++;
    }
    return json.length - pairs;
}
function measure(v) {
    if (v === null)
        return 4;
    if (typeof v === 'number')
        return numberLength(v);
    if (typeof v === 'string')
        return textLength(v);
    if (typeof v === 'boolean')
        return v ? 4 : 5;
    if (Array.isArray(v)) {
        if (!v.length)
            return 2;
        let n = 2 + 2 * (v.length - 1);
        for (const x of v)
            n += measure(x);
        return n;
    }
    const entries = Object.entries(v);
    if (!entries.length)
        return 2;
    let n = 2 + 2 * (entries.length - 1);
    for (const [k, x] of entries)
        n += textLength(k) + 2 + measure(x);
    return n;
}
/** The characters `value`'s jsonb text has: what `char_length(payload::text)` counts once it is stored. */
export function storedLength(value) {
    const json = JSON.stringify(value);
    if (json === undefined)
        return 0;
    return measure(JSON.parse(json));
}
//# sourceMappingURL=stored.js.map